export const queryKeys = {
  auth: {
    account: 'getAccounts',
    listUser: 'getListUser'
  },
  announcement: {
    detail: 'getAnnouncementDetail',
    list: 'listAnnouncement'
  },
  content: {
    list: 'listContent'
  },
};
